export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10809.3946618a.jpg";